<template>
  <el-dialog
    :visible.sync="dialogVisible"
    top="20%"
    class="prompt-dialog"
    append-to-body
    destroy-on-closes
    :show-close="false"
    v-on="$listeners"
  >
    <h3
      class="font-black text-xl leading-normal text-left lg:text-center lg:text-3xl lg:leading-normal"
      :class="customTitleClass"
    >
      <slot name="title">{{ title }}</slot>
    </h3>
    <slot name="content">
      <pre class="whitespace-pre-wrap my-10 lg:text-left">{{ content }}</pre>
    </slot>
    <slot name="action">
      <div class="text-center">
        <el-button class="cancel-btn" @click="onCancel">{{ $t('common.action.close') }}</el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'PromptDialog',
  props: {
    visible: Boolean,
    content: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    customTitleClass: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/confirm-dialog.scss';
</style>
